<template>
  <v-card :class="classP" :disabled="loading">
    <v-card-text :class="'card-text text-start py-2 ' + type" disabled>
      <v-icon :class="'main-icon ' + type">{{ icon }}</v-icon>
      <div :class="'info-text ' + type">{{ title }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ElSavitarnaIcon',
  props: {
    classP: String,
    disabled: Boolean,
    loading: Boolean,
    active: Boolean,
    icon: String,
    type: String,
    title: String,
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';

.card-text {
  min-height: 70px;
  height: 100%;
  border: 1px solid $backgroundIcon;
  padding: 0px;
  position: relative;
  overflow: hidden;
  color: #fff;
  cursor: pointer;

  &.sutartis {
    border: 1px solid $sutartisBackgroundIcon;
  }
  &.ntrpaslauga {
    border: 1px solid $ntrpaslaugaBackgroundIcon;
  }

  .main-icon {
    position: absolute;
    top: 10px;
    left: 5px;
    color: $savitarnaIcon;
    font-size: 50px;

    &.active {
      color: #eee;
    }
    &.ntrpaslauga {
      left: 10px;
    }
  }
  .overlay {
    color: #fff;
  }

  .info-text {
    padding-top: 5px;
    padding-left: 60px;
    padding-right: 10px;
    font-size: 0.8rem;
    color: var(--v-primary-base);

    &.sutartis {
      color: $sutartis;
    }
    &.ntrpaslauga {
      color: $ntrpaslauga;
      padding-left: 75px;
      padding-right: 20px;
    }
  }
}
</style>
